export default Object.freeze({
	UploadContacts: 0,
	SelectTemplates: 1,
	MapContactsFields: 2,
	SaveTemplates: 3,
	AssignGroups: 4,
	CheckDuplicates: 5,
	CheckErrors: 6,
});
